import { render, staticRenderFns } from "./UpdateSupplierUserPopUp.vue?vue&type=template&id=5969af98&scoped=true&"
import script from "./UpdateSupplierUserPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateSupplierUserPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSupplierUserPopUp.vue?vue&type=style&index=0&id=5969af98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969af98",
  null
  
)

export default component.exports